<template>
  <div style="background: white;">
    <carousel class="slides" :data="slides" :interval="3500" indicator-trigger="hover"></carousel>
    <!-- <img src="../assets/start_up/sl1.png" alt="World's Largest Webinar | How to Start A Start Up | For Solopreneures & Students"> -->

    <!-- <br /> -->

    <div style="background: white; padding: 20px; margin-top: 70px; margin-left: auto; margin-right: auto; max-width: 800px">
      <h1>Are You an Educational Institute or Own A Business?</h1>
      <h2>If you have 1000+ Employee/Clients/Students, We will help you increase your brands visibility for FREE before, after and during this event (FREE).*</h2>
      <a href="#contact" rel="noopener noreferrer">Contact Us</a> to learn more.
    </div>

    <div class="product_info_bg uk-margin-large-top">
      <h2 class="uk-text-center">World's Largest Webinar - How to Start a StartUp</h2>
      <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-first-column"
        >
          <div id="changeprone" class="uk-background-contain">
            <iframe
              width="550"
              height="309"
              src="https://www.youtube.com/embed/C9QkPz6JZgw"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative"
        >
          <div style="padding-top: 20px" class="info_div">
            <p>
              World’s Largest Webinar For Solopreneurs &amp; Students. Topics to be covered during the Webinar:
              <br />
              <br />How to start a startup?
              <br />How to raise funds?
              <br />How to find TAMs - total addressable Market?
              <br />How to get the first 100 customers?
              <br />How to know the perfect customer?
              <br />How to validate your idea?
              <br />How to build MVP - minimum viable product?
              <br />How find the right problem to solve? Mujhe kya aata hai, mujhe kya bhaata hai, market kya chahta hai?
              <br />Who to raise seed funds?
              <br />How to get selected by a Startup incubator / accelerator?
              <br />How to build the right personality that attracts success?
              <br />How to go from pocket money to professional salary?
              <br />Difference between an employee, intrapreneur and entrepreneur.
              <br />How to influence people and create success?
            </p>
          </div>
          <div class="know_more uk-margin-top">
            <button data-href="#">Register Above</button>
            <br />
            <a
              href="https://f-qr.github.io/bb/PPT%2015%20Aug%20How%20to%20Start%20A%20Start%20Up%20Event.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Download Brochure</button>
            </a>
          </div>
        </div>
      </div>
    </div>

    <a class="wa" href="https://f-qr.github.io/?wa" target="_blank" rel="noopener noreferrer">
      <img src="../assets/wa.png" alt="WhatsApp" />
    </a>
    <!-- <form @submit.prevent="submit">
      <h1>Contact Us</h1>
      <p>
        <input v-model="name" placeholder="Name" />
      </p>
      <p>
        <input v-model="instName" placeholder="Institute Name" />
      </p>
      <p>
        <select v-bind="phCode">
          <option v-for="(code, key) in codes" :key="key" :value="code">{{code + ' (' + key + ')'}}</option>
        </select>
        <input maxlength="15" type="Mobile" placeholder="Mobile Number" v-model="phone" />
      </p>
      <p>
        <input type="email" v-model="email" />
      </p>
      <div>
        <select name="pr_product" id="header_product" v-model="product" class="uk-select uk-border-pill">
          <option selected="selected">Select Product</option>
          <option value="163">World&#039;s Largest Webinar - How to Start a StartUp</option>
          <option value="86">Become an Independent Business Consultant (IBC)</option>
          <option value="8">Everything About Entrepreneurship (EAE) Program</option>
          <option value="153">Problem Solving Courses (PSC)</option>
          <option value="36">Life Time Membership (LTM)</option>
          <option value="26">WHITE LABELLING Solutions</option>
          <option value="154">Case Studies Project</option>
        </select>
      </div>
    </form>-->
    <div id="contact">
      <div>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfCkY7EWVF2IS02hfIaEGjRY4iOj1PDRL_A-mJzgPmQocip5Q/viewform?embedded=true"
          width="640"
          height="1369"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >Loading…</iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { codes } from "../store/contry_codes.js";
export default {
  name: "Sponsor",
  metaInfo: {
    title: "How to Start A Start Up Sponsorship",
  },
  data() {
    return {
      slides: [],
      name: "",
      instName: "",
      phCode: "",
      phone: "",
      email: "",
      product: "",
      codes,
    };
  },
  methods: {
    submit() {},
  },
  created() {
    var img = document.createElement("img");
    var alt = [
      "World's Largest Webinar | How to Start A Start Up | For Solopreneures & Students",
    ];
    for (var i = 0; i < 22; i++) {
      img.src = require(`../assets/start_up/k${i + 1}.jpg`);
      img.style.maxWidth = "100%";
      img.style.maxHeight = "80vh";
      this.slides.push(img.outerHTML);
    }
  },
  mounted() {
    setTimeout(() => {
      window.scroll({
        top: 5000,
        left: 0,
        behavior: "smooth",
      });
    }, 200);
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, 1000);
  },
};
</script>
<style scoped lang="scss">
#changeprone{
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

#changeprone>iframe{
  max-width: 90vw;
  max-height: calc(720/1280*90vw);
}
h1, h2{
  text-align: justify;
}
#contact{
  width: 100vw;
  overflow: auto;
}
#contact>div {
  min-width: 650px;
  height: 1240px;
  overflow: hidden;
  text-align: center;
}
html {
  scroll-behavior: smooth;
}
.wa {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}
.wa > img {
  max-width: 100px;
}

.slides {
  margin-bottom: -20px;
}
</style>